import React, { useState } from 'react';
import { Box, Button, Container, TextField } from '@mui/material';
import { makeStyles } from '@mui/styles';
import account from '../services/account-service';
import { useNavigate } from 'react-router-dom';
import { storageHandler } from '../utils/storage_handler';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import jwt_decode from 'jwt-decode';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    justifyContent: 'center',
    alignItems: 'center',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
});

export default function LoginPage() {
  const classes = useStyles();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleLogin = async () => {
    const response = await account.login({ username, password });
    if (response.success) {
      storageHandler.localStorageSet('token', response.result.token);
      navigate('/');
    }
  };

  const handleGoogleSuccess = async (credentialResponse) => {
    const decoded = jwt_decode(credentialResponse.credential);
    console.log('Google user info:', decoded);

    // Send credentialResponse.credential to backend for verification
    const response = await account.googleLogin({
      token: credentialResponse.credential,
    });
    if (response.success) {
      storageHandler.localStorageSet('token', response.result.token);
      navigate('/');
    }
  };

  const handleGoogleError = () => {
    console.log('Google Login Failed');
  };

  return (
    <GoogleOAuthProvider clientId='603843170179-u2qcu1qtlok7d81nghhb7uus16v56etc.apps.googleusercontent.com'>
      <Container className={classes.root}>
        <Box component="form" className={classes.form} noValidate autoComplete="off">
          <TextField
            id="username"
            label="Username"
            variant="outlined"
            margin="normal"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          <TextField
            id="password"
            label="Password"
            type="password"
            variant="outlined"
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <Button variant="contained" color="primary" onClick={handleLogin}>
            Login
          </Button>
          <Box mt={2}>
            <GoogleLogin onSuccess={handleGoogleSuccess} onError={handleGoogleError} />
          </Box>
        </Box>
      </Container>
    </GoogleOAuthProvider>
  );
}
